import * as React from 'react';
import { ComposableCard, useClickableCard } from '@leagueplatform/genesis-core';
import { InternalOrExternalLink as Link } from '@leagueplatform/web-common-components';
import type { SmallIconCoverageCardProps } from '#types/coverage-detail-widget-cards.types.ts';

type SmallIconCardProps = SmallIconCoverageCardProps;

export function SmallIconCard({
  title = '',
  indicator = 'chevron',
  image,
  onClick,
  href,
}: SmallIconCardProps) {
  const { clickAreaRef, primaryActionRef, onCardMouseDown, onCardMouseUp } =
    useClickableCard();

  // Genesis Core ComposableCard.Body expects the chevron to be 'rightChevron'
  const trailingIndicator =
    indicator === 'chevron' ? 'rightChevron' : indicator;
  const isLink = !!href;

  return (
    <ComposableCard.Root
      backgroundColor="secondary"
      css={{ width: '100%' }}
      onCardMouseDown={onCardMouseDown}
      onCardMouseUp={onCardMouseUp}
      ref={clickAreaRef}
    >
      <ComposableCard.Body
        headingLevel="display"
        heading={title}
        trailingIndicator={trailingIndicator}
        imageSrc={image?.url}
        imageAltText={image?.description || ''}
        imagePosition="leading"
        onClick={onClick}
        linkAs={isLink ? Link : undefined}
        href={isLink ? href : undefined}
        ref={primaryActionRef}
      />
    </ComposableCard.Root>
  );
}
